import { request, rootRequest, qs } from './api';

// POST /admin/generate-notification-copy -> { data:{ title, body }, status }
export const generateNotificationCopy = (body) =>
  request('/generate-notification-copy', { method: 'POST', body });

// GET /get-messaging -> { data:[{id,device_id,fcm_token,user_id,created_at,updated_at}], ... }
export const listMessagingTokens = (params) => rootRequest(`/get-messaging${qs(params)}`);

// POST /send-notification
// Single token:   { token, title, body, image?, link?, data? }  (admin Bearer auth)
// Device token:   same body, but authenticated via X-Device-Token header
// Broadcast:      { title, body, link? }  (omit token/device_id/user_id)
export const sendNotification = (payload, { deviceToken } = {}) =>
  rootRequest('/send-notification', {
    method: 'POST',
    body: payload,
    ...(deviceToken && { headers: { 'X-Device-Token': deviceToken } }),
  });
